import React from 'react';
import VariantList from "./VariantList";
import RegularVariantData from "./RegularVariantData";

const VariantData = (props, { type, }) => {
    let isSingleProduct = props.variants.length === 1;

    if(isSingleProduct){
        return <RegularVariantData {...props}/>
    }

    return <VariantList {...props}/>
};

export default VariantData;
